
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#989AB2","d":"M17.659 1.302a4.443 4.443 0 00-6.285 0L7.66 5.017c-1.795 1.795-1.629 4.656 0 6.286.273.272.575.495.893.678l.678-.678c.445-.445.288-.965.28-1.34a2.252 2.252 0 01-.28-.232c-.836-.836-.873-2.27 0-3.143l3.714-3.715a2.225 2.225 0 013.142 0 2.224 2.224 0 010 3.143l-2.454 2.456c.07.393.497 1.323.277 2.859l.035-.028 3.714-3.715a4.446 4.446 0 000-6.286z"}}),_c('path',{attrs:{"fill":"#989AB2","d":"M11.588 7a4.222 4.222 0 00-.893-.678L10.017 7c-.445.444-.288.964-.28 1.34.097.069.192.143.28.23.836.837.873 2.27 0 3.144l-4.002 4.003a2.225 2.225 0 01-3.142 0 2.224 2.224 0 010-3.143L5.615 9.83c-.07-.393-.497-1.323-.277-2.859-.011.011-.024.018-.035.028l-4.001 4.003a4.445 4.445 0 006.284 6.286l4.002-4.003c1.762-1.762 1.665-4.62 0-6.285z"}})])
          )
        }
      }
    